// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ReferenceDataResponse } from './reference-data-response';

/** See com.rev360.pms.api.controller.accounting.PersonInsuranceSummaryResponse */
/* istanbul ignore next */
@GandalfModel
export class PersonInsuranceSummaryResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: Number })
	practiceInsuranceCompanyId!: number | null;

	@GandalfConstantDecorator(constants.InsuranceCompanyStatus)
	@GandalfProperty({ designType: constants.InsuranceCompanyStatus })
	practiceInsuranceCompanyStatus!: constants.InsuranceCompanyStatus | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	priority!: ReferenceDataResponse | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	type!: ReferenceDataResponse | null;

}
